module.exports = __webpack_public_path__ + "static/media/markerD.7f8eb5b0.svg";